module.exports = __webpack_public_path__ + "static/media/simulationGraph2.9a4c360c.png";